import { FileDelimiter } from "./FileDelimiter";
import { TableFormat } from "./TableFormat";

/** Utility class for processing files. Eg. exporting and importing file data. */
export class FileLogic {

  /**
   * Return file extension from filename
   * @param fileName import file name as string
   * @returns TableFormat or null
   */
  public static getExtensionFromFileName(fileName: string): string | undefined {
    const reqex = /(?:\.([^.]+))?$/;
    const match = reqex.exec(fileName);
    return match?.[1];
  }



  /**
   * Return delimiter from provided data
   * @param data import data as string
   * @returns returns FileDelimiter
   */
  public static getFileDelimiter(data: string): FileDelimiter {
    if (data) {
      const map = new Map<FileDelimiter, number>([
        [FileDelimiter.Comma, data.split(FileDelimiter.Comma).length],
        [FileDelimiter.Semicolon, data.split(FileDelimiter.Semicolon).length],
        [FileDelimiter.Tab, data.split(FileDelimiter.Tab).length],
      ]);

      const result = [...map.entries()].reduce((a,c) => c[1]> a[1] ? c : a);
      return result[1] > 0 ? result[0] : FileDelimiter.Unknown;
    }
    return FileDelimiter.Unknown;
  }

  /**
   * Returns locale
   * @param csv input csv data
   * @returns returns locale as string
   */
  public static getCsvLocale(csv: FileDelimiter): any {
    return csv === FileDelimiter.Semicolon ? "fi" : "en";
  }

  /**
   * return table format
   * @param fileDelimiter delimeter used to figure table format
   * @returns table format
   */
  public static getTableFormatByDelimeter(fileDelimiter: FileDelimiter): TableFormat {
    return fileDelimiter === FileDelimiter.Comma || fileDelimiter === FileDelimiter.Semicolon ? TableFormat.Csv : TableFormat.Txt;
  }

}
